import React, { useState, useEffect } from 'react';

// API URL'i tanımlama ve debug
const baseURL = process.env.REACT_APP_API_URL;
console.log('UrunDuzenleModal - API URL:', baseURL);

function UrunDuzenleModal({ urun, isOpen, onClose, onSave, kategoriler }) {
    const [formData, setFormData] = useState({});
    // YENİ: Seçilen fotoğraf dosyasını tutmak için state
    const [selectedFile, setSelectedFile] = useState(null);
    // YENİ: Yüklenen fotoğrafın önizlemesini göstermek için state
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (urun) {
            setFormData(urun);
            // Eğer ürünün mevcut bir fotoğrafı varsa, önizlemeyi ayarla
            if (urun.fotograf_yolu) {
                // Backend uploads route'u /api/uploads şeklinde tanımlandığı için doğrudan kullanıyoruz
                const imageUrl = `${baseURL}/api/uploads/${urun.fotograf_yolu}`;
                console.log('Base URL:', baseURL);
                console.log('Fotoğraf URL:', imageUrl);
                setPreview(imageUrl);
            } else {
                setPreview(null);
            }
        }
        // Modal kapandığında seçili dosyayı ve önizlemeyi temizle
        if (!isOpen) {
            setSelectedFile(null);
            setPreview(null);
        }
    }, [urun, isOpen]);

    if (!isOpen) {
        return null;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // YENİ: Dosya seçildiğinde çalışacak fonksiyon
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            // Seçilen dosyanın önizlemesini oluştur
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Kaydetme işlemini, hem form verisi hem de seçilen dosya ile ana bileşene bildir
        onSave(formData, selectedFile);
    };

    // --- Stil tanımlamaları (değişiklik yok) ---
    const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
    const modalContentStyle = {
        background: '#F8F8F8', // Yeni zemin rengi
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)', // Yeni gölge
        border: '1px solid #C2C2C2', // Yeni çerçeve
        width: '800px',
        maxHeight: '90vh',
        overflowY: 'auto',
        fontFamily: 'Poppins, sans-serif' // <-- YENİ: Ana font eklendi
    };
    const formStyle = { display: 'flex', gap: '60px' };
    const imageContainerStyle = { width: '300px', height: '300px', background: '#e2e2e2', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', color: '#555', borderRadius: '8px', overflow: 'hidden', position: 'relative' };
    const inputGroupStyle = { display: 'flex', flexDirection: 'column', gap: '30px', flex: 1 };
    const inputStyle = {padding: '8px 12px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        flex: 1, fontFamily: 'Poppins, sans-serif' };
    const labelStyle = { width: '150px', fontWeight: '500' };
    const fieldRowStyle = { display: 'flex', alignItems: 'center', gap: '10px' };

    return (
        <div style={modalOverlayStyle} onClick={onClose}>
            <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
                <form onSubmit={handleSubmit}>
                    <div style={formStyle}>
                        {/* --- FOTOĞRAF YÜKLEME ALANI (GÜNCELLENDİ) --- */}
                        <div style={{ textAlign: 'center' }}>
                            <div style={imageContainerStyle}>
                                {preview ? (
                                    <img src={preview} alt="Ürün Önizleme" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                    <span>ÜRÜN RESMİ YOK</span>
                                )}
                            </div>
                            <input 
                                type="file" 
                                accept="image/png, image/jpeg"
                                onChange={handleFileChange} 
                                style={{ marginTop: '10px' }} 
                            />
                        </div>
                        <div style={inputGroupStyle}>
                            <div style={fieldRowStyle}>
                                <label style={labelStyle}>Ürün Kodu</label>
                                <input type="text" name="urun_kodu" value={formData.urun_kodu || ''} onChange={handleChange} style={inputStyle} />
                            </div>
                            <div style={fieldRowStyle}>
                                <label style={labelStyle}>Ürün Adı</label>
                                <input type="text" name="urun_adi" value={formData.urun_adi || ''} onChange={handleChange} style={inputStyle} />
                            </div>
                            <div style={fieldRowStyle}>
                                <label style={labelStyle}>Kategori</label>
                                <select name="kategori" value={formData.kategori || ''} onChange={handleChange} style={inputStyle}>
                                    <option value="">Kategori Seçiniz</option>
                                    {kategoriler && kategoriler.map(kat => (<option key={kat} value={kat}>{kat}</option>))}
                                </select>
                            </div>
                            <div style={fieldRowStyle}>
                                <label style={labelStyle}>Fiyat</label>
                                <input type="number" name="fiyat" value={formData.fiyat || ''} onChange={handleChange} style={inputStyle} />
                            </div>
                            <div style={fieldRowStyle}>
                                <label style={labelStyle}>Ebat</label>
                                <input type="text" name="ebat" value={formData.ebat || ''} onChange={handleChange} style={inputStyle} />
                            </div>
                            <div style={fieldRowStyle}>
                                <label style={labelStyle}>Paraşüt ID</label>
                                <input 
                                    type="text" 
                                    name="parasut_id" 
                                    value={formData.parasut_id || ''} 
                                    onChange={handleChange} 
                                    style={inputStyle}
                                    placeholder="Paraşüt ürün ID'si"
                                />
                            </div>
                            <div style={fieldRowStyle}>
                                <label style={labelStyle}>Wix ID</label>
                                <input 
                                    type="text" 
                                    name="wix_id" 
                                    value={formData.wix_id || ''} 
                                    onChange={handleChange} 
                                    style={inputStyle}
                                    placeholder="Wix ürün ID'si"
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '25px', marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                        <button type="button" onClick={onClose} style={{
                            width: '110px',
                            height: '37px', // Yazının rahat sığması için yüksekliği biraz artırdım
                            background: '#F8F8F8',
                            borderRadius: '8px',
                            border: '0.50px black solid',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>Vazgeç</button>
                        <button type="submit" style={{
                            width: '110px',
                            height: '37px',
                            background: '#F8F8F8', // Şimdilik ikisi de aynı stilde
                            borderRadius: '8px',
                            border: '0.50px black solid',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>Tamam</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default UrunDuzenleModal;